import { useState } from "react";
import { Form, Button, Container, Spinner } from "react-bootstrap";
import "../../../styles/GenerateDoc.css";
import SuperAdminHeader from "../SuperAdminHeader.js";
import SuperAdminSidebar from "../SuperAdminSidebar.js";
import instance from "../../../services/endpoint.js";
import { toast } from "react-toastify";

const GenerateDoc = () => {
  const [formData, setFormData] = useState({
    Cur_Date: "",
    Lender_Title: "",
    Lender_Name: "",
    Lender_Relation_Title: "",
    Lender_Relation_Name: "",
    Lender_Age: "",
    Lender_Full_Address: "",
    Lender_Aadhar_Number: "",
    Lender_Amount: "",
    Lender_Amount_English: "",
    LendeeAccountID: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 
    try {
      const response = await instance.post("/api/v1/generateDoc/loanagreement", formData);
      toast.success("Document generated successfully!");
      setFormData({
        Cur_Date: "",
        Lender_Title: "",
        Lender_Name: "",
        Lender_Relation_Title: "",
        Lender_Relation_Name: "",
        Lender_Age: "",
        Lender_Full_Address: "",
        Lender_Aadhar_Number: "",
        Lender_Amount: "",
        Lender_Amount_English: "",
        LendeeAccountID: "",
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to generate document");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <>
      <SuperAdminHeader page="dashboard" />
      <SuperAdminSidebar />
    <Container className="my-5 generate-doc-container">
    {/* <Container> */}
      <h2 className="text-center mb-4">Get Loan Agreement</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Date of Agreement</Form.Label>
          <Form.Control
            type="date"
            name="Cur_Date"
            value={formData.Cur_Date}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Lender's Title</Form.Label>
          <Form.Select
            name="Lender_Title"
            value={formData.Lender_Title}
            onChange={handleChange}
            required>
            <option value="">Select Title</option>
            <option value="Mr.">Mr.</option>
            <option value="Mrs.">Mrs.</option>
            <option value="Ms.">Ms.</option>
            <option value="Miss">Miss</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Lender's Full Name</Form.Label>
          <Form.Control
            type="text"
            name="Lender_Name"
            value={formData.Lender_Name}
            onChange={(e) => {
              const value = e.target.value;
              // Allow only letters, space, and periods
              if (/^[a-zA-Z\s.]*$/.test(value)) {
                setFormData((prev) => ({ ...prev, Lender_Name: value }));
              }
            }}
            placeholder="Enter Full Name"
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Relation Type</Form.Label>
          <Form.Select
            name="Lender_Relation_Title"
            value={formData.Lender_Relation_Title}
            onChange={handleChange}
            required>
            <option value="">Select Relation</option>
            <option value="S/O">S/O</option>
            <option value="D/O">D/O</option>
            <option value="W/O">W/O</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Parent/Spouse Name</Form.Label>
          <Form.Control
            type="text"
            name="Lender_Relation_Name"
            value={formData.Lender_Relation_Name}
            onChange={(e) => {
              const value = e.target.value;
              // Allow only letters, space, and periods
              if (/^[a-zA-Z\s.]*$/.test(value)) {
                setFormData((prev) => ({
                  ...prev,
                  Lender_Relation_Name: value,
                }));
              }
            }}
            placeholder="Enter Parent/Spouse Full Name"
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Lender's Age</Form.Label>
          <Form.Control
            type="number"
            name="Lender_Age"
            value={formData.Lender_Age}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (
                !/[0-9]/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Tab"
              ) {
                e.preventDefault();
              }
            }}
            min="18"
            max="100"
            required
          />
          <Form.Text muted>*Age must be between 18 and 100.</Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Residential Address</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="Lender_Full_Address"
            value={formData.Lender_Full_Address}
            onChange={handleChange}
            placeholder="Enter Full Residential Address"
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Aadhaar Number</Form.Label>
          <Form.Control
            type="text"
            name="Lender_Aadhar_Number"
            value={formData.Lender_Aadhar_Number}
            onChange={(e) => {
              const cleaned = e.target.value.replace(/\D/g, "");
              if (cleaned.length <= 12) {
                setFormData((prev) => ({
                  ...prev,
                  Lender_Aadhar_Number: cleaned,
                }));
              }
            }}
            placeholder="Enter 12-digit Aadhaar"
            required
          />
          <Form.Text muted>*Aadhaar must be exactly 12 digits.</Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Loan Amount (in ₹)</Form.Label>
          <Form.Control
            type="number"
            name="Lender_Amount"
            value={formData.Lender_Amount}
            onChange={(e) => {
              const cleaned = e.target.value.replace(/\D/g, "");
              setFormData((prev) => ({ ...prev, Lender_Amount: cleaned }));
            }}
            onKeyDown={(e) => {
              if (
                !/[0-9]/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Tab"
              ) {
                e.preventDefault();
              }
            }}
            placeholder="Enter amount in digits"
            min="1"
            required
          />
          <Form.Text muted>
            *Enter the amount you’re lending in numbers.
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Loan Amount (in Words)</Form.Label>
          <Form.Control
            type="text"
            name="Lender_Amount_English"
            value={formData.Lender_Amount_English}
            onChange={handleChange}
            placeholder="e.g., Fifty Thousand Only"
            required
          />
        </Form.Group>

          <Form.Group className="mb-3">
          <Form.Label>Account ID</Form.Label>
          <Form.Control
            type="text"
            name="LendeeAccountID"
            value={formData.LendeeAccountID}
            onChange={(e) => {
              const cleaned = e.target.value.replace(/\D/g, "");
              if (cleaned.length <= 11) {
                setFormData((prev) => ({
                  ...prev,
                  LendeeAccountID: cleaned,
                }));
              }
            }}
            placeholder="Enter 11-digit Account ID"
            required
          />
          <Form.Text muted>*LendeeAccountID must be exactly 11 digits.</Form.Text>
        </Form.Group>

        <div className="text-center">
          <Button
            variant="primary"
            type="submit"
            disabled={loading}
            className="px-4 py-2">
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Generating Document...
              </>
            ) : (
              "Generate Document"
            )}
          </Button>
        </div>
      </Form>
      <div className="mt-4 alert alert-warning small text-center" role="alert">
        <strong>Note:</strong> <br />
        This Loan Agreement PDF is generated automatically based on the information provided by you.
        The website owner/developer shall not be held liable for any errors, omissions, or legal consequences arising from the use of this generated document. By using this tool, you acknowledge and agree that you do so at your own risk.
      </div>
    </Container>
    </>
  );
};

export default GenerateDoc;
